// extracted by mini-css-extract-plugin
module.exports = {"BrowseCarsByPriceRangeCustomWidth":"CarsPrices-module__BrowseCarsByPriceRangeCustomWidth"};